export default class Company {
    id = null
    name = null

    constructor(props = null) {
        if (props) {
            Object.assign(this, props);
        }
    }
}